(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('error-report', {
            parent: 'app',
            url: '/admin/error-report',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/error-report/error-report.html',
                    controller: 'ErrorReportController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
